/**
 * Checks if value is null or undefined.
 *
 * @param value The value to check.
 * @returns Returns true if value is null or undefined, else false.
 */
export function isNil(value) {
    return value == null;
}
//# sourceMappingURL=general.js.map